import React from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import Button from "../../../../../components/elements/Button";
import EditableField from "../../../../../components/elements/EditableField";

import ProjectBlocksContainerEditor from "./blocks/ProjectBlocksContainerEditor";

import {
    createEmptyHint
} from "../shared/factories";

export default function HintsEditor({

                                        hints,

                                        path,

                                        updateAtPath

                                    }) {

    const addHint = () => {

        updateAtPath(
            path,

            [

                ...hints,

                createEmptyHint()

            ]
        );

    };

    const removeHint = (index) => {

        updateAtPath(
            path,

            hints.filter((_, i) => i !== index)
        );

    };

    return (

        <details className="border rounded-md bg-white" open={false}>
            <summary className="cursor-pointer p-5 font-semibold">
                <span>Hints ({hints.length})</span>
                <Button onClick={addHint}>
                    <FontAwesomeIcon icon={faPlus}/>
                </Button>
            </summary>


            <div className="p-5 flex flex-col gap-6">
                {
                    hints.map((hint, index) => (

                        <div
                            key={hint.id}
                            className="border rounded-md bg-white p-5 flex flex-col gap-5"
                        >

                            <div className="flex justify-between">

                            <span>

                                {hint.id}

                            </span>

                                <Button
                                    onClick={() =>
                                        removeHint(index)
                                    }
                                >

                                    <FontAwesomeIcon icon={faTrash}/>

                                </Button>

                            </div>

                            <EditableField

                                title="Energy Cost"

                                type="number"

                                value={hint.energyCost}

                                onSave={(value) => {

                                    updateAtPath(
                                        [...path, index, "energyCost"],

                                        Number(value)
                                    );

                                }}

                            />

                            <ProjectBlocksContainerEditor

                                title="Hint"

                                container={hint.content}

                                path={[...path, index, "content"]}

                                updateAtPath={updateAtPath}

                            />

                        </div>

                    ))

                }

            </div>
        </details>
    );
}